<script lang="ts">
	import BuyCampfireLink from "@components/BuyCampfireLink.svelte";
	import FrequentlyAskedQuestion from "@components/FrequentlyAskedQuestion.svelte";
	import { getFaqPath } from "@core/schema/paths/getFaqPath.js";
	import { getIdFromPath } from "@core/schema/utils/getIdFromPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="bg-background-dim full-width grid-container">
	<div class="container-8 mx-auto">
		<h2 class="mb-16 text-center font-bold" id={getIdFromPath(getFaqPath(tenant.locale))}>Otázky a odpovědi</h2>
		<div class="flex flex-col gap-4">
			<FrequentlyAskedQuestion question="Je ohniště na uhlí nebo na dřevo?">
				Na obojí. Ohniště je navržené tak, aby bez problémů fungovalo s dřevem i dřevěným uhlím. Záleží jen na tom, co
				zrovna potřebujete. Jestli večerní oheň na opékání, nebo stabilní žár pro grilování.
			</FrequentlyAskedQuestion>
			<FrequentlyAskedQuestion
				question="Můžu si s tímto ohništěm rozdělat oheň v kempu, kde není povolené klasické ohniště?"
			>
				V mnoha kempech jsou zakázaná klasická ohniště právě kvůli riziku poškození terénu. Přenosné ohniště je však
				šetrné k podkladu, nespálí trávu ani půdu, nešíří oheň do stran a popel zůstává uvnitř. Díky tomu je často
				tolerováno i tam, kde byste oheň jinak rozdělávat nesměli.
			</FrequentlyAskedQuestion>
			<FrequentlyAskedQuestion question="Kde si můžu legálně rozdělat oheň v přírodě?">
				V přírodě platí pravidla. Oheň se smí rozdělávat jen na vyhrazených místech. V národních parcích a CHKO je to
				často zakázané. Přenosné ohniště může být bezpečnější a šetrnější varianta, ale vždy doporučujeme ověřit si
				pravidla konkrétní lokality.
			</FrequentlyAskedQuestion>
			<FrequentlyAskedQuestion question="Můžu si ohniště rozdělat i na balkoně?">
				Na balkon radši ne. Kvůli požární bezpečnosti to není povolené. Sousedům by mohl vadit kouř, nebo je naopak
				přiláká vůně buřtů dřív, než je stihnete sníst! Ale venku? To je jiná liga. Vemte ohniště dolů před panelák, na
				dvůr nebo do parku a klidně rovnou pozvěte sousedy. Z večera u ohně se tak snadno stane nejlepší moment týdne.
			</FrequentlyAskedQuestion>
			<FrequentlyAskedQuestion question="Jak se mám o ohniště starat, aby vydrželo co nejdéle?">
				Jednoduše: nechte ho vychladnout, vysypte popel a případně otřete. Žádné natírání, žádné drátování, žádné
				chemie. Materiály jako kotlová ocel, nerez, pozink, jsou odolné a připravené zvládnout sezónu za sezónou. Čím
				víc ho používáte, tím víc mu to sluší.
			</FrequentlyAskedQuestion>
		</div>
	</div>
	<BuyCampfireLink class="mx-auto mt-10" />
</section>
